export const UNSELECTED_CHANNEL = 'UNSELECTED_CHANNEL';
export const SELECTED_CHANNEL = 'SELECTED_CHANNEL';